import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import { IGetMealPlanListResponse, MealPlan } from './interfaces';

export const getMealPlanList = async (): Promise<MealPlan[]> => {
  const response: AxiosResponse<IGetMealPlanListResponse> = await apiClient.get(
    '/meal-plan/list'
  );

  return response.data.data;
};
